import * as React from 'react'
import {
  useGetWorkRegions,
  useGetVendorWorkRegions,
  useEndWorkRegionForVendor,
  useSetWorkRegionForVendor
} from 'vendors/queries/useWorkRegionQuery'

type UseWorkRegionResponse = {
  workRegionListProps: {
    onChange: (event: React.ChangeEvent<HTMLInputElement>) => void
    selectedRegions: string[]
    workRegions: WorkRegionsResponseType[]
  }
  isLoading: boolean
  isError: boolean
}

const useWorkRegion = (vendorId: string): UseWorkRegionResponse => {
  const { isLoading: isWorkRegionsLoading, data: workRegions = [] } = useGetWorkRegions()
  const { isLoading, data, isError } = useGetVendorWorkRegions(vendorId)

  const { mutate: setWorkRegion, isError: isSetWorkRegionError } = useSetWorkRegionForVendor(vendorId)

  const { mutate: endWorkRegion, isError: isEndWorkRegionError } = useEndWorkRegionForVendor(vendorId)

  const selectedRegions = React.useMemo(() => {
    if (!data) {
      return []
    }

    return data.map((item) => item.workRegionId)
  }, [data])

  const onChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { id, checked } = event.target
    if (checked) {
      setWorkRegion(id)
    } else {
      endWorkRegion(id)
    }
  }

  return {
    workRegionListProps: {
      onChange,
      selectedRegions,
      workRegions
    },
    isLoading: isLoading || isWorkRegionsLoading,
    isError: isError || isSetWorkRegionError || isEndWorkRegionError
  }
}

export default useWorkRegion
